export default __webpack_public_path__ + "static/media/1873.f989e0aa.png";